"use client";

import React from "react";
import { SessionProvider } from "next-auth/react";
export default function Providers(props) {
  return (
    <SessionProvider
      basePath="/akreditasi/api/auth"
      // setiap 10 menit fetch
      refetchInterval={10 * 60}
    >
      {props.children}
    </SessionProvider>
  );
}
